








import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { BillingInfoSwitchResourceModel, BillingInfoType } from '@/modules/billing-info/models/billing-info-resource'
import {
  adminInvoiceBillingInfoTableColumns
} from '@/modules/invoice/models/columns/admin-invoice-billing-info-table.column'
import AdminInvoiceBillingInfoTableRow
  from '@/modules/invoice/components/admin/billing-info-table/AdminInvoiceBillingInfoTableRow.vue'
import QTable from 'quasar/src/components/table/QTable.js';

@Component({
  components: {
    TesTable
  }
})
export default class AdminInvoiceBillingInfoTable extends Vue {

  @ProvideReactive()
  @Prop({ required: true, default: () => [] }) billingInfo!: BillingInfoSwitchResourceModel
  private columns = this.columnFilter()
  private rowComponent = AdminInvoiceBillingInfoTableRow

  columnFilter(): QTable['columns'] {
    return (this.billingInfo.type === BillingInfoType.LEGAL)
      ? adminInvoiceBillingInfoTableColumns().filter(item => item.name.includes('legal'))
      : adminInvoiceBillingInfoTableColumns().filter(item => item.name.includes('natural'))
  }
}
